import { Location } from 'react-router-dom';

export const getParamFromLocationSearchParams = ({
  location,
  param,
}: {
  location: Location;
  param: string;
}): string | null => {
  const query = new URLSearchParams(location.search);
  return query.get(param);
};
